module.exports = __webpack_public_path__ + "static/media/lock.6d3ec527.png";